import { Text } from "@chakra-ui/react";

export const LinkDivider: JSX.Element = (
  <Text color="fg-on-accent" px={1} size="xl">
    |
  </Text>
);
